import { Skeleton } from '@dixa/lib-shared-habla';
import { MetricInstrumentData } from 'lib-analytics-ui';
import { PropsWithClassName } from 'lib-shared-types-utils';
import { memo } from 'react';

import { useChannelDashboardChannelContext } from '../../../../channelDashboardChannel.context';
import { ChannelDashboardMetric } from '../../../metric/channelDashboardMetric';

type ChannelDashboardResponseTimeMetricProps = PropsWithClassName;

export const ChannelDashboardResponseTimeMetric = memo(
  function ChannelDashboardResponseTimeMetric({
    className,
  }: ChannelDashboardResponseTimeMetricProps): JSX.Element {
    const { metrics, isSkeleton } = useChannelDashboardChannelContext();

    return (
      <ChannelDashboardMetric
        className={className}
        title="Avg. response time"
        isSkeleton={isSkeleton}
        metricType="response_time"
      >
        {isSkeleton ? (
          <Skeleton height="24px" width="72px" />
        ) : (
          <MetricInstrumentData
            data={metrics?.average_response_time ?? null}
            format="duration"
          />
        )}
      </ChannelDashboardMetric>
    );
  },
);
